import { Box, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import CommandBar from '../CommandBar/CommandBar.component'

export default function ModalDialog({
    open = false,
    title = null,
    titleComponent = 'h2',
    commands = [],
    onClose,
    fullWidth = true,
    maxWidth = 'sm',
    paperSx,
    containerSx,
    contentSx,
    children,
}) {
    if (!open) {
        return null
    }

    const close = (reason) => {
        if (reason === 'backdropClick' && commands.length > 0) {
            return
        }

        onClose?.()
    }

    return (
        <Dialog
            open
            onClose={(event, reason) => close(reason)}
            fullWidth={fullWidth}
            maxWidth={maxWidth}
            slotProps={{
                paper: { sx: paperSx },
                container: { sx: containerSx },
            }}
        >
            {title != null && (
                <DialogTitle component={titleComponent}>{title}</DialogTitle>
            )}

            <DialogContent sx={contentSx}>
                {children}
            </DialogContent>

            {commands.length > 0 && (
                <DialogActions>
                    <Box sx={{ flex: 1 }}>
                        <CommandBar commands={commands} />
                    </Box>
                </DialogActions>
            )}
        </Dialog>
    )
}
